import { render, staticRenderFns } from "./SectionBanner.vue?vue&type=template&id=47bcfb1a&scoped=true&"
import script from "./SectionBanner.vue?vue&type=script&lang=js&"
export * from "./SectionBanner.vue?vue&type=script&lang=js&"
import style0 from "./SectionBanner.vue?vue&type=style&index=0&id=47bcfb1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bcfb1a",
  null
  
)

export default component.exports